<script setup>
defineProps(['method', 'iconClass'])
</script>

<template>
  <!--  https://icon-sets.iconify.design/noto/-->
  <svg xmlns="http://www.w3.org/2000/svg" :class="iconClass" viewBox="0 0 128 128">
    <template v-if="method === 'Oral'">
      <path
        fill="#f44336"
        d="M74.06 115.46c11.38 11.38 30.01 11.38 41.4 0c11.38-11.38 11.38-30.01 0-41.4L84.7 43.3L43.3 84.7z"
      />
      <path
        fill="#fdd835"
        d="M84.7 43.3L53.94 12.54c-11.38-11.38-30.01-11.38-41.4 0c-11.38 11.38-11.38 30.01 0 41.4L43.3 84.7z"
      />
      <path fill="#c62828" d="m86.819 45.423l-41.4 41.401l-2.122-2.12l41.4-41.403z" />
      <path
        fill="#fff"
        d="M69.43 36.25C81.59 49.5 103.65 74.5 103.65 74.5c2.86 2.61 6.79 9.34 4.22 11.66c-2.74 2.48-9.12-2.75-11.98-5.36L49.22 36.89c-2.85-2.61-12.39-11.06-10.53-17.01c3.51-11.23 17.2 1.61 30.74 16.37"
        opacity="0.65"
      />
    </template>
    <template v-if="method === 'Oral Suspension'">
      <path
        fill="#9fe1ea"
        d="M106.64 52.3c0-5.39-.1-9.76-2.52-14.7c-1.47-3.01-7.34-11.23-8.51-12.26H33.04c-1.17 1.03-7.04 9.25-8.51 12.26c-2.42 4.93-2.52 9.31-2.52 14.7c0 7.73.03 56.22-.01 57.05c-.11 2.72 1.83 4.85 4.93 6.84c9.95 6.38 28.64 7.81 37.39 7.81s27.44-1.43 37.39-7.81c3.11-1.99 5.04-4.12 4.93-6.84c-.03-.83 0-49.32 0-57.05"
        opacity="0.8"
      />
      <ellipse cx="64" cy="110.45" fill="#1492c4" opacity="0.6" rx="35.86" ry="8.47" />
      <path
        fill="#1492c4"
        d="m33.05 25.09l-3 4.03s18 13.26 52.75 7.91c19.58-3.01 14.68-8.85 14.68-8.85l-2.82-4.33z"
        opacity="0.6"
      />
      <path
        fill="#fff"
        d="M40.99 91.6c.64 8.18-8.75 11.52-11.34 3.32c-.86-2.73-.43-5.67-.16-8.52c.65-6.69.49-13.45-.46-20.1c-.9-5.85-2.01-19.47 3.88-22.44c2.58-1.3 4.62-.67 6.57.32c2.85 1.66 3.18 5.58 3.1 8.87c-.15 5.66-.76 11.3-1.2 16.94c-.48 6.23-1.89 10.85-1.17 15.84c.27 1.92.69 3.85.78 5.77"
        opacity="0.8"
      />
      <path
        fill="#e2a610"
        d="M99.79 12.1H28.17s-.82 2.18-.77 5.9c.07 6.72 1.94 7.26 4.36 8.4c5.89 2.77 17.12 4.68 32.17 4.68s26.28-1.9 32.17-4.68c2.42-1.14 4.29-1.68 4.36-8.4c.04-3.72-.67-5.9-.67-5.9"
      />
      <ellipse cx="64" cy="12.47" fill="#9e740b" rx="35.86" ry="8.47" />
      <path
        fill="#ffe36c"
        d="M40.94 20.94c5.35.65 6.23.65 6.72 2.27c.22.75.05 1.63-.53 2.14c-2.79 2.46-9.47 1.28-12.23-.8c-.98-.74-2.23-2.74-.71-4.09c1.43-1.26 4.5.21 6.75.48"
      />
    </template>
    <template v-if="method === 'Injection'">
      <path
        fill="#848484"
        d="M106.88 22.97L103.91 20l13.94-13.94c.69-.69 1.27-.93 1.84-.94l3.96.2c.32.02.47.42.24.65z"
      />
      <ellipse
        cx="18.69"
        cy="108.19"
        fill="#b9e4ea"
        rx="3.14"
        ry="17.17"
        transform="rotate(-45.001 18.686 108.195)"
      />
      <path
        fill="#82aec0"
        d="M16.58 110.3C11.4 105.12 5.72 97.54 6.55 96.05l-2.02 2.02c-2.14 2.14 2.47 8.4 9.17 15.1s12.96 11.31 15.1 9.17l2.02-2.02c-1.05 1.07-9.06-4.84-14.24-10.02"
      />
      <path
        fill="#b9e4ea"
        d="M26.99 114.45s-2.32-.43-8.22-6.34c-5.9-5.9-6.34-8.22-6.34-8.22l22.62-22.62l14.56 14.56zm35.59-25.86l43.35-43.35c.52-.52.52-1.37 0-1.89L83.52 20.96a1.34 1.34 0 0 0-1.89 0L38.32 64.27s-2.48.86-6.02-1.28c-2.02-1.23-3.64-2.08-5.43-.29c0 0-.76 2.99 16.65 20.4s20.8 16.7 20.8 16.7c1.02-1.02.57-2.73-.63-5.4c-1.46-3.22-1.11-5.81-1.11-5.81"
      />
      <path
        fill="#00937a"
        d="M106.51 20.37a3.971 3.971 0 0 0-5.63 0l-9.06 9.06l5.63 5.63l9.06-9.06a3.971 3.971 0 0 0 0-5.63"
      />
      <path
        fill="#12d8b7"
        d="m94.06 30.74l-1.4-1.4l7.3-7.3a.984.984 0 0 1 1.4 0c.39.39.39 1.02 0 1.4z"
      />
      <path
        fill="#82aec0"
        d="M55.9 85.54s-2.32-.43-8.22-6.34s-6.34-8.22-6.34-8.22l17.52-17.52l14.56 14.56zm7.59 15.13c.33-.39.65-.78 1.02-1.13c-.25.06-.52.03-.76-.06c-.25-.09-.46-.23-.66-.4c-1.43-1.19-2.86-2.38-4.27-3.59c-2.2-1.89-4.37-3.81-6.51-5.77a239.56 239.56 0 0 1-7.82-7.47c-2.54-2.54-5.02-5.14-7.45-7.78c-1.94-2.11-3.85-4.26-5.72-6.43c-.68-.79-1.36-1.59-2.03-2.39c-.6-.72-1.44-1.48-1.73-2.37c-.11-.35-.15-.72-.05-1.07c-1.16.79-2.07 1.93-3.07 2.92a.9.9 0 0 0-.08 1.19c1.46 1.94 6.5 8.3 17.32 19.12c10.8 10.8 17.02 15.7 18.92 17.13c.36.27.86.23 1.18-.08l1.08-1.08c.22-.26.43-.5.63-.74"
      />
      <path
        fill="#fff"
        d="M83.52 25.81c1.84 1.84-.69 4.01-.69 4.01S48.89 63.5 45.22 67.14c-1.14 1.14-2.36 2.69-4.02 2.92c-2.5.25-4.94-1.29-6.39-3.25c-.19-.26-.21-.64.18-.57c3.66.78 4.85-.16 7.23-2.79c1.93-1.91 34.73-34.5 37.37-37.12c1.03-1.02 2.44-2.02 3.93-.52"
      />
      <path fill="#455a64" d="M81.45 66.77L60.17 45.63l-5.53 5.51l21.21 21.23z" />
      <path
        fill="#212121"
        d="m59.83 52.65l1.85-1.87a2.607 2.607 0 0 1 3.69 0l12.62 12.54c1.03 1.03 1.01 2.71-.02 3.74l-1.85 1.85a2.625 2.625 0 0 1-3.72 0L59.82 56.34a2.616 2.616 0 0 1 .01-3.69"
      />
    </template>
  </svg>
</template>

<style scoped></style>
